import React from 'react';
import { InputQ1TextAreaWrapper, InputLabel, IconTextAreaWrapper } from '../styles';
import { AutoResizeTextArea } from 'components/Input';
import utils from 'utils';
import actions from 'state/actions';
import { FieldInputType, FieldTriggerConfig } from 'models/response';

interface TextAreaInputProps {
  field: any;
  helpers: any;
  multi?: boolean;
  index?: number;
  label: string;
  readonly: boolean;
  feedbackColor: string;
  hasFeedback: boolean;
  feedbackMessage: string;
  autoViewInPage: () => void;
  dispatch: any;
  fieldInputType: FieldInputType;
  name: string;
  icon: JSX.Element;
  triggerConfig: FieldTriggerConfig | null;
  executeActionQ1: () => void;
}

export const TextAreaInputComponent: React.FC<TextAreaInputProps> = ({
  field,
  helpers,
  multi,
  index,
  label,
  readonly,
  feedbackColor,
  hasFeedback,
  feedbackMessage,
  autoViewInPage,
  dispatch,
  fieldInputType,
  name,
  icon,
  triggerConfig,
  executeActionQ1,
}) => {
  let value = '';
  try {
    value = multi && (index || index === 0) ? field.value.content[index].content : field.value.content[0].content;
  } catch (e) {
    console.error(e);
    utils.app.notify('warning', `Field ${name}:${label} received with a non valid value`, 5000, 'non-valid-value');
  }

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    if (field.value) {
      const arrayValues = [...field.value.content];
      arrayValues[multi && (index || index === 0) ? index : 0] = {
        ...field.value.content[multi && (index || index === 0) ? index : 0],
        content: e && e.target.value ? e.target.value : '',
        boundingBox: { x1: -1, x2: -1, y1: -1, y2: -1 },
        pageNumber: -1,
        confidence: -1,
        status: 0,
      };
      helpers.setValue({
        ...field.value,
        content: arrayValues,
      });
      if (triggerConfig) executeActionQ1();
    }
  };

  const handleBlur = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    if (e.target.value && field.value) {
      const arrayValues = [...field.value.content];
      arrayValues[multi && (index || index === 0) ? index : 0] = {
        ...field.value.content[multi && (index || index === 0) ? index : 0],
        content: e.target.value,
        status: 3,
      };
      helpers.setValue({
        ...field.value,
        content: arrayValues,
      });
    }
  };

  const onFocus = () => {
    autoViewInPage();
    field.value &&
      dispatch(
        actions.documents.setFocussedQ1({
          fieldInputType,
          name,
          multi,
          index,
        }),
      );
  };

  return (
    <>
      <InputQ1TextAreaWrapper multi={multi} margin={multi ? '0 0 0 -4px' : '0'}>
        <InputLabel title={label} style={{ paddingTop: '7px' }}>
          {label}
        </InputLabel>
        <AutoResizeTextArea
          feedbackColor={feedbackColor}
          hasFeedBack={hasFeedback}
          feedBackMessage={feedbackMessage}
          value={value}
          onChange={handleChange}
          onBlur={(e) => handleBlur(e)}
          onFocus={onFocus}
          name={name}
          resize={true}
          limitHeight={true}
          minHeight={30}
          maxHeight={175}
          disabled={readonly}
        />
      </InputQ1TextAreaWrapper>
      <IconTextAreaWrapper>{icon}</IconTextAreaWrapper>
    </>
  );
};
